/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { useMergeState } from 'irmlib/hooks'
import styled from 'styled-components'
// import { FlexByRow, FloatRight, XDivider, HalfScreen, makeStyles } from 'irmlib/styles'
import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
// import { Label, ToolTip, OutlinedButton } from 'irmlib/components/Controls'
// import { Edit } from 'irmlib/icons'
import Table from '../../Controls/Table'
// import * as constants from 'irmlib/common/constants'
import { useTranslation } from 'react-i18next'
import { Visibility } from '@material-ui/icons'

// const ROW_SELECTED = 'rowSelected'
// const NOT_SELECTED = 'notSelected'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 0px;
`
const TableContainer = styled(BottomPaddedDiv)`
`
// const useStyles = makeStyles({
//   disabledState: {
//     pointerEvents: 'none',
//     opacity: '0.4'
//   },
//   editIcon: {
//     cursor: 'pointer'
//   }
// })

// const CenteringFlexRow = styled(FlexByRow)`
//   align-items: center;
// `
const initialState = {
  selectedImage: null
}

const RequestTemplateFormat = (props) => {
  const { t } = useTranslation()
  const [, setState, getState] = useMergeState(initialState)
  // const [selectedImage, setSelectedImage] = React.useState(null)
  // const classes = useStyles()
  const columns = [
    {
      title: props?.fromMultiReqs ? t('tableColumns.requestId') : t('tableColumns.templateId'),
      field: 'requestId',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.customTemplateName'),
      field: 'customTemplateName',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('templates.createdBy'),
      field: 'createdBy',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('templates.createdOn'),
      field: 'createdOn',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.templateFields'),
      field: 'requestFields',
      textAlign: 'center',
      width: '40%',
      sortable: false,
      render: (rowData) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {rowData.requestFields.map((field, index) => (
            <span key={index} style={{ padding: '0 20px 0 0', maxWidth: '50%' }}>{field}</span>
          ))}
        </div>
      ),
    },
    {
      title: t('tableColumns.imgReference'), 
      field: 'imgReference',
      width: '30%',
      render: rowData => (
        rowData.imgReference 
          ? (
            <Visibility
            style={{ cursor: 'pointer', fontSize: 32 }} 
              onClick={() => {
                if (props.onImageClick) {
                  props.onImageClick(rowData.imgReference)
                } else {
                  setState({ selectedImage: rowData.imgReference })
                }
              }}
          />
            )
          : null
      ),
    },
  ]
  
  const addImagesColumns = [
    {
      title: props?.fromMultiReqs ? t('tableColumns.requestId') : t('tableColumns.templateId'),
      field: 'requestId',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.customRequestName'),
      field: 'customRequestName',
      textAlign: 'center',
      width: '40%',
      sortable: false,
    },
    {
      title: t('tableColumns.templateFields'),
      field: 'requestFields',
      textAlign: 'center',
      width: '40%',
      sortable: false,
      render: (rowData) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {rowData.requestFields.map((field, index) => (
            <span key={index} style={{ padding: '0 20px 0 0', maxWidth: '50%' }}>{field}</span>
          ))}
        </div>
      ),
    },
    {
      title: t('tableColumns.lockedFields'),
      field: 'lockedFields',
      textAlign: 'center',
      width: '40%',
      sortable: false,
      render: (rowData) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {rowData.lockedFields?.map((field, index) => (
            <span key={index} style={{ padding: '0 20px 0 0', maxWidth: '50%' }}>{field}</span>
          ))}
        </div>
      ),
    },
    {
      title: t('tableColumns.status'),
      field: 'status',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.imgReference'), 
      field: 'imgReference',
      width: '30%',
      render: rowData => (
        rowData.imgReference 
          ? (
            <Visibility
            style={{ cursor: 'pointer', fontSize: 32 }}  
              onClick={() => {
                if (props.onImageClick) {
                  props.onImageClick(rowData.imgReference)
                } else {
                  setState({ selectedImage: rowData.imgReference })
                }
              }}
          />
            )
          : null
      ),
    },
  ]



  const handleClose = () => {
    setState({ selectedImage: null })
  }

  const ImageContainer = () => {
    return (
      <Dialog open={!!getState().selectedImage} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            <img 
              src={getState().selectedImage} 
              alt="Box Image" 
              style={{ width: '100%', height: 'auto', maxWidth: '400px', maxHeight: '400px' }} 
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
  

  const getPageData = async (page, pageSize) => {
    const dataRows = await props.getPageData(page, pageSize)
    return Promise.resolve(dataRows)
  }

  const onSelectionChange = (rows, row, val) => {
    if (rows.length > 1) {
      const requestList = props.tableRef.current.dataManager.data
      let index = 0
      for (const selectedRow of requestList) {
        if (row.requestId !== selectedRow.requestId) {
          if (requestList[index].tableData.checked) {
            requestList[index].tableData.checked = false
          }
        }
        ++index
      }
      props.tableRef.current.setState(requestList)
    }

    if (props.selectedRecord !== false) {
      if (row.tableData.checked) {
        props.selectedRecord(row.requestId)
      } else {
        props.selectedRecord(false)
        if (props.currentTemplateId) {
          props.selectedRecord(props.currentTemplateId)
        }
      }
    }
  }

  return (
    <>
      <TableContainer>
        <Table
          title={props.title}
          tableRef={props.tableRef}
          reportFor={props?.reportFor}
          totalRecords={200}
          columns={props?.fromImageCapture ? addImagesColumns : columns}
          getPageData={getPageData}
          rowsPerPageOptions={[30]}
          exportButton={false}
          paging={false}
          draggable={false}
          sorting={false}
          onSelectionChange={onSelectionChange}
          selection={true}
          showSelectAllCheckbox={false}
          />
      </TableContainer>
      <ImageContainer/>
    </>
  )
}

RequestTemplateFormat.propTypes = {
  tableRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  // jobDetails: PropTypes.string,
  getPageData: PropTypes.func,
  selectedRecord: PropTypes.func,
  fromMultiReqs: PropTypes.bool,
  fromImageCapture: PropTypes.bool,
  currentTemplateId: PropTypes.any,
  onImageClick: PropTypes.func,
}

export default RequestTemplateFormat